'use client';

import { useState } from 'react';
import CardFooterView from './card-footer-view';
import { usePathname } from 'next/navigation';

interface Props {
  markdown: string;
  onShowSolution: (baseUrl: string) => void;
}

const CardFooterDefaultContainer = ({ markdown, onShowSolution }: Props) => {
  const baseUrl = usePathname();
  const [showAnswer, setShowAnswer] = useState(false);

  return (
    <CardFooterView
      markdown={markdown}
      showAnswer={showAnswer}
      onToggleAnswer={() => setShowAnswer(prev => !prev)}
      onNavigateToSolution={() => onShowSolution(baseUrl)}
    />
  );
};

export default CardFooterDefaultContainer;
